/**
 * Kebab-style mobile menu trigger — three vertically-stacked brand dots
 * in an outline square button. Designed to sit on dark surfaces.
 *
 * Props:
 *   onClick    — click handler
 *   ariaLabel  — accessible name (default: "More options")
 *   disabled   — disables interaction
 *   badge      — show a notification dot on the top-right corner
 *   className  — extra classes on the root button
 *
 * The badge is decorative (aria-hidden): a bare dot has no useful screen-reader
 * text, and whatever it is counting is announced elsewhere. It is positioned by
 * this component because only this component knows where its own border is.
 */
export default function MobileMenuButton({
  onClick,
  ariaLabel = 'More options',
  disabled = false,
  badge = false,
  className = '',
  ...props
}) {
  const classes = ['mobile-menu-btn', className].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      {...props}
    >
      <span className="mobile-menu-btn__dot" aria-hidden="true" />
      <span className="mobile-menu-btn__dot" aria-hidden="true" />
      <span className="mobile-menu-btn__dot" aria-hidden="true" />
      {badge && <span className="mobile-menu-btn__badge" aria-hidden="true" />}
    </button>
  );
}
